module.exports = __webpack_public_path__ + "logo.png?583c2a323cd56b103ae6ff204bf63f8c";